module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGd563392063a91d9f390b8eb7978773f7.d5633920.png";